import React, { Component } from 'react';

class Tile extends Component {

    static get CSS_WIDTH_EM() {
        return 6;
    }

    static get CSS_HEIGHT_EM() {
        return 12;
    }

    constructor(props) {
        super(props);

        this.getSuitClassNames = this.getSuitClassNames.bind(this);
        this.obtainTileWithStyle = this.obtainTileWithStyle.bind(this);
    }

    obtainTileWithStyle(a, b, style) {

        // Build top spans
        let top = this.getSuitClassNames(true)[a].map(
            item => <span key={'T'.concat(item)} className={item}></span>
        );

        // Build line span
        let line = <span className="line"></span>;

        // Build bottom spans
        let bottom = this.getSuitClassNames(false)[b].map(
            item => <span key={'B'.concat(item)} className={item}></span>
        );

        let id = `tile${a}${b}`;
        let cn = (this.props.clickHandler)? 'isendpoint': '';
        // Build domino div with top, line, and bottom spans
        return <div id={id} className={`domino ${cn}`} style={style} onClick={this.props.clickHandler}>
            {top}
            {line}
            {bottom}  
        </div>;
    }

    getSuitClassNames(isTop) {

        // Prefix every class name with top or bottom key letter as expected by css
        let topOrBottom = isTop ? "T" : "B";

        return [
            [],
            [ `${topOrBottom}C135` ],
            [ `${topOrBottom}L23456`, `${topOrBottom}R23456` ],
            [ `${topOrBottom}L23456`, `${topOrBottom}C135`, `${topOrBottom}R23456` ],
            [ `${topOrBottom}L456`, `${topOrBottom}L23456`, `${topOrBottom}R23456`, `${topOrBottom}R456` ],
            [ `${topOrBottom}L456`, `${topOrBottom}L23456`, `${topOrBottom}C135`, `${topOrBottom}R23456`, `${topOrBottom}R456` ],
            [ `${topOrBottom}L456`, `${topOrBottom}L6`, `${topOrBottom}L23456`, `${topOrBottom}R23456`, `${topOrBottom}R6`, `${topOrBottom}R456` ]
        ];
    }

    render() {


        let newA = this.props.a > this.props.b ? this.props.b : this.props.a;
        let newB = this.props.a > this.props.b ? this.props.a : this.props.b;
        let cursor = this.props.clickHandler ? 'pointer' : 'default';

        let style = {
            'left': `${this.props.x}px`,
            'top': `${this.props.y}px`,
            'transform': `rotate(${this.props.d}deg)`,
            'fontSize': this.props.tileTextSize,
            'width': `${Tile.CSS_WIDTH_EM}em`,
            'height': `${Tile.CSS_HEIGHT_EM}em`,
            'cursor': `${cursor}`
        };

        return this.obtainTileWithStyle(newA, newB, style);
    }
}
export default Tile;


// WEBPACK FOOTER //
// ./src/Tile.jsx